export const columns = [
  {
    title: '编号',
    customRender: (text, record, index)=>index+1,
  },
  {
    title: '调研模板名称',
    dataIndex: 'name',
  },
  {
    title: '医生名称',
    dataIndex: 'user_realname',
  },
  {
    title: '反馈信息',
    dataIndex: 'info',
    scopedSlots: { customRender: 'info' },
  },
  {
    title: '创建时间',
    dataIndex: 'create_time',

  },
];
